import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Select, MenuItem, IconButton } from '@material-ui/core';
import { serviceCategoryType } from 'types/global';
import IconPicker from 'components/custom/IconPicker/IconPicker'
import Icon from '@material-ui/core/Icon'
import CloseIcon from '@material-ui/icons/Close'
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import CustomInput from 'components/CustomInput/CustomInput';
import Button from 'components/CustomButtons/Button';
import selectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";
import withStyles from "@material-ui/core/styles/withStyles"

class ServiceCategoryDialog extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      serviceCategoryName: props?.selectedServiceCategory?.name ?? '',
      parentBusinessCategory: props?.selectedServiceCategory?.parentCategoryId,
      pickedIcon: false,
    };
  }

  handleSubmitServiceCategoryForm = () => {
    const {
      isEditMode,
      handleAddServiceCategory,
      handleEditServiceCategory,
      selectedServiceCategory
    } = this.props;
    const {
      serviceCategoryName,
      parentBusinessCategory,
      pickedIcon,
    } = this.state;

    if (isEditMode) {
      handleEditServiceCategory(
        selectedServiceCategory.id,
        serviceCategoryName,
        parentBusinessCategory,
        'materialUiIcons',
        pickedIcon.name,
      );
    } else {
      handleAddServiceCategory(
        serviceCategoryName,
        parentBusinessCategory,
        'materialUiIcons',
        pickedIcon.name,
      );
    }
  }

  onServiceCategoryNameChange = e => {
    this.setState({ serviceCategoryName: e.target.value });
  }

  onServiceCategoryParentCategoryChange = e => {
    this.setState({
      parentBusinessCategory: e.target.value
    })
  }

  showPickedIcon = (icon) => {
    this.setState({
      pickedIcon: icon,
    })
  }

  render() {
    const {
      isEditMode, handleServiceCategoryDialogClose, businessCategories, classes
    } = this.props;
    const {
      serviceCategoryName,
      parentBusinessCategory,
      pickedIcon,
    } = this.state;
    return (
      <Dialog
        open
        onClose={handleServiceCategoryDialogClose}
        aria-labelledby="form-dialog-title"
        fullWidth
      >
        <DialogTitle>
          {isEditMode ? 'Edit Service Category' : 'Add Service Category'}
          <IconButton
            style={{
              position: 'absolute', color: 'grey',
              right: '14px', top: '10px',
            }}
            onClick={handleServiceCategoryDialogClose}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <GridContainer >
            <GridItem xs={12} md={12} >
              <CustomInput
                id="name"
                labelText='Service Category Name'
                inputProps={{
                  disabled: false,
                  type: 'text',
                  maxLength: '50',
                  onChange: this.onServiceCategoryNameChange,
                  value: serviceCategoryName
                }}
                formControlProps={{ fullWidth: true }}
                autoFocus
              />
              {this.props?.showParentCategory &&
                <FormControl
                  className={classes.selectFormControl}
                  style={{ paddingTop: 10 }}
                  fullWidth
                >
                  <Select
                    label="Parent Business Category"
                    value={parentBusinessCategory != null && parentBusinessCategory != "" ? parentBusinessCategory : 'none'}
                    onChange={this.onServiceCategoryParentCategoryChange}
                    fullWidth
                    MenuProps={{
                      className: classes.selectMenu,
                    }}
                    classes={{
                      select: classes.select,
                    }}
                  >
                    {businessCategories && businessCategories.map(bct => (
                      <MenuItem
                        value={bct.id}
                        key={bct.id}
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}>
                        {bct.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              }
              <GridContainer alignItems="center">
                <GridItem>
                  <IconPicker
                    onPick={this.showPickedIcon}
                  />
                </GridItem>
                <GridItem>
                  {this.state.pickedIcon.name &&
                    <Icon>{this.state.pickedIcon.name}</Icon>
                  }
                </GridItem>
              </GridContainer>
            </GridItem>
          </GridContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleServiceCategoryDialogClose} >
            Cancel
          </Button>
          <Button
            disabled={!serviceCategoryName}
            onClick={this.handleSubmitServiceCategoryForm}
            color="rose">
            {isEditMode ? 'Edit' : 'Add'}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

ServiceCategoryDialog.propTypes = {
  handleServiceCategoryDialogClose: PropTypes.func.isRequired,
  handleEditServiceCategory: PropTypes.func.isRequired,
  handleAddServiceCategory: PropTypes.func.isRequired,
  isEditMode: PropTypes.bool.isRequired,
  selectedServiceCategory: serviceCategoryType,
};

ServiceCategoryDialog.defaultProps = {
  isEditMode: false
};

export default withStyles(selectStyle)(ServiceCategoryDialog);
